import {
  C_GENERAL,
  C_LEGAL_DOCUMENTS,
  C_TRADING_HOURS,
} from "../../constants/types";

export const DebPath = (category, subCategory, dir) => {
  let path = "";
  if (category === C_LEGAL_DOCUMENTS) {
    path = `category/${category}/${subCategory}/${dir}_dir/`;
  } else if (category === C_GENERAL || category === C_TRADING_HOURS) {
    path = `category/${category}/${dir}_dir/`;
  } else {
    path = `category/${category}/`;
  }

  return path;
};

export const StoragePath = (category, subCategory, dir, fileName) => {
  let path = "";
  if (category === C_LEGAL_DOCUMENTS) {
    path = `${category}/${subCategory}/${dir}_dir/${fileName}`;
  } else if (category === C_GENERAL || category === C_TRADING_HOURS) {
    path = `${category}/${dir}_dir/${fileName}`;
  } else if (category === "credit_bonus" || category === "merch_manager") {
    path = `${category}/${subCategory}/${fileName}`;
  } else {
    path = `${category}/${fileName}`;
  }

  return path;
};

/* export const SetPathToFile = (category, subCategory, dir, fileName) => {
  let filePath = "";
  if (category === C_LEGAL_DOCUMENTS) {
    filePath = `https://firebasestorage.googleapis.com/v0/b/go-marketing-apps.appspot.com/o/${category}%2F${subCategory}%2F${dir}_dir%2F${fileName}?alt=media`;
  } else if (category === C_GENERAL || category === C_TRADING_HOURS) {
    filePath = `https://firebasestorage.googleapis.com/v0/b/go-marketing-apps.appspot.com/o/${category}%2F${dir}_dir%2F${fileName}?alt=media`;
  } else if (category === "credit_bonus" || category === "merch_manager") {
    filePath = `https://firebasestorage.googleapis.com/v0/b/go-marketing-apps.appspot.com/o/${category}%2F${subCategory}%2F${fileName}?alt=media`;
  } else {
    filePath = `https://firebasestorage.googleapis.com/v0/b/go-marketing-apps.appspot.com/o/${category}%2F${fileName}?alt=media`;
  }
  return filePath;
}; */

export const SetPathToFile = (category, subCategory, dir, fileName) => {
  let filePath = "";

  if (category === C_LEGAL_DOCUMENTS) {
    filePath = `${category}/${subCategory}/${dir}_dir/${fileName}`;
  } else if (category === C_GENERAL || category === C_TRADING_HOURS) {
    filePath = `${category}/${dir}_dir/${fileName}`;
  } else if (category === "credit_bonus" || category === "merch_manager") {
    filePath = `${category}/${subCategory}/${fileName}`;
  } else {
    filePath = `${category}/${fileName}`;
  }

  return `https://gom.digital/files/${filePath
    .split("/")
    .map(encodeURIComponent)
    .join("/")}`;
};